import * as api from "Api";
import * as actions from "Actions";

export const fetchCollaborators = (searchWord, roles = null, year) => {
  return (dispatch, getState) => {
    const { uen } = getState().auth.currentOrganization;
    const synchro =
      getState().fiduciary.data && getState().fiduciary.data.synchro;

    const { paginationPage, pageSize } = getState().collaboratorList;
    let noLimit = false;
    let data = {
      paginationPage,
      pageSize,
      uen,
      searchWord,
      noLimit,
      roles,
      year,
      synchro
    };
    dispatch(
      actions.fetchCollaborators(
        api.getCollaborators(data).then(res => {
          return res.data.data;
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/collaborator.js